const common = {
    no_data: 'Tiada data tersedia',
    header: {
        business_name: 'Perniagaan Anda'
    },
    download_app: {
        text: 'Untuk menggunakan versi web Simply, sila gunakan komputer riba atau PC.',
        button: 'Muat turun versi mudah alih'
    },
    unknown: 'Tidak diketahui',
    request_error: 'Ralat berlaku. Sila cuba lagi! Atau hubungi sokongan pelanggan untuk melaporkan isu anda.',
    home: 'Laman Utama',
    dashboard: 'Papan Pemuka',
    product: 'Produk',
    add_product: 'Tambah Produk',
    edit_product: 'Sunting Produk',
    stock_in: 'Stok Masuk',
    Sales_Turnover: 'Pusing Ganti Jualan',
    profit: 'Keuntungan',
    stock_out: 'Stok Keluar',
    staff: 'Kakitangan',
    stock_audit: 'Audit Stok',
    button: {
        save: 'Simpan',
        save_and_add_more: 'Simpan & Tambah Lagi',
        submit: 'Hantar',
        done: 'Selesai',
        edit: 'Sunting',
        save_edit: 'Simpan Perubahan',
        yes: 'Ya',
        clear: 'Kosongkan',
        delete: 'Padam',
        cancel: 'Batal',
        reset: 'Set Semula'
    },
    select_date: 'Pilih Tarikh',
    select_action: 'Pilih Tindakan',
    mandatory: ' *(Diperlukan)',
    not_mandatory: '(Tidak Diperlukan)',
    business: 'Perniagaan',
    account: 'Akaun',
    profile: 'Profil',
    setting: 'Tetapan',
    whichLanguage: 'Bahasa Melayu',
    headerDashboard: 'Jadi VIP',
    contact_us: 'Hubungi Kami',
    logout: 'Log Keluar',
    category: 'Kategori',
    add_category: 'Tambah Kategori',
    data: 'Data',
    history: 'Sejarah',
    lowStockAlert: 'Amaran Stok Rendah',
    Expenses: 'Perbelanjaan',
    lowStockAlertButton: 'Tambah Kuantiti Stok Keselamatan',
    message: {
        login_success: 'Berjaya Log Masuk!',
        onboard_success: 'Tahniah!! Perjalanan anda bermula!',
        successfully_saved: 'Data berjaya disimpan',
        successfully_deleted: 'Data berjaya dipadam',
        error_required_field: 'Medan wajib tidak boleh kosong',
        no_access: 'Tiada akses',
        no_permission: 'Anda tiada kebenaran',
        error_update_history: 'Gagal mengemas kini sejarah'
    },
    no_permission_dialog: {
        title: 'Tiada Kebenaran',
        description: 'Anda tiada kebenaran untuk melihat Perbelanjaan. Sila hubungi pentadbir anda.'
    },
    feedback: 'Berikan maklum balas',
    contact: 'Hubungi',
    add: 'Tambah',
    supplier: 'Pembekal',
    customer: 'Pelanggan',
    random: 'Rawak',
    scan: 'Imbas',
    enter: 'Log masuk dengan mengimbas kod bar',
    terms: {
        text: 'Dengan meneruskan, anda bersetuju dengan',
        link: 'Dasar Privasi'
    },
    others: 'Lain-lain',
    calender: {
        presets: {
            today: 'Hari Ini',
            yesterday: 'Semalam',
            last_7_days: '7 Hari Terakhir',
            last_30_days: '30 Hari Terakhir',
            this_month: 'Bulan Ini',
            last_month: 'Bulan Lepas',
            custom_range: 'Julat Tersuai'
        }
    },
    print_large: 'Cetak Besar (A4)',
    print_letter: 'Cetak Surat (US)',
    print_dot_matrix: 'Cetak Besar (Dot Matrix)',
    print_medium: 'Cetak Sederhana (75mm)',
    print_small: 'Cetak Kecil (48mm)',
    format: 'Format Kertas',
    preview: 'Pratonton',
    view_invoice: 'Invois',
    view_chalan: 'Challan',
    price: 'Harga',
    stock: 'Stok',
    quantity: 'Kuantiti',
    total: 'Jumlah',
    print_footer_left: 'Dicipta oleh',
    print_footer_center: 'Dicetak pada',
    print_footer_date: 'pada',
    print_to: 'Kepada',
    language: 'Bahasa Melayu',
    dateStatus: '7 Hari Terakhir',
    placeholder: 'Jenis Transaksi',
    staffHistory: 'Pilih Kakitangan',
    languageTitle: 'Bahasa Melayu',
    date: 'Tarikh',
    download: 'Muat Turun',
    download_excel: 'Muat Turun Excel',
    download_pdf: 'Muat Turun Kod Bar',
    currentTitle: 'Mata Wang',
    Selectperiod: 'Pilih tempoh',
    TransactionType: 'Jenis Transaksi',
    SelectCustomer: 'Pilih Pelanggan',
    invoice: 'Invois',
    login: {
        google: 'Log Masuk dengan Google',
        apple: 'Log Masuk dengan Apple'
    },
    trusted_by: {
        title: 'Dipercayai oleh lebih 50,000 perniagaan \n di seluruh Indonesia 🇮🇩'
    },
    privacyPolicyOne: "Dengan mendaftar masuk, anda bersetuju dengan Simply's",
    privacyPolicyTwo: 'Dasar Privasi',
    manufacture: 'Pembuatan',
    warehouse: 'Gudang',
    error: {
        title: 'Oops! Ada sesuatu yang tidak kena',
        description: 'Ralat tidak dijangka berlaku. Sila segarkan halaman atau kembali ke laman utama.',
        refresh: 'Segarkan Halaman',
        go_back: 'Kembali ke Laman Utama',
        not_found: 'Halaman Tidak Dijumpai'
    },
    totalPurchasePrice: 'Jumlah Harga Pembelian',
    pageTotalPurchaseAmount: 'Jumlah Jumlah Pembelian Halaman',
    approval_status: 'Status kelulusan',
    pending: 'Belum selesai',
    approved: 'Diluluskan',
    rejected: 'Ditolak',
    select_fields: 'Pilih Bidang',
    syncWithTally: 'Segerakkan dengan Tally',
    importFromTally: 'Import dari Tally',
    exportToTally: 'Eksport ke Tally',
    All: 'Semua',
    Approval: 'Kelulusan'
}
export default common